import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Task } from './task/task';
import { HttpClient, HttpContext } from '@angular/common/http';
import { BYPASS_LOG } from 'libs/auth/src/lib/auth.interceptor';

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  constructor(private http: HttpClient) {}
  public getFilteredTasks = (): Observable<Task[]> =>
    this.http.get<Task[]>(
      `https://js.devexpress.com/Demos/RwaService/api/Employees/FilteredTasks`, { context: new HttpContext().set(BYPASS_LOG, true) }
    );

  public getTask = (id: number): Observable<Task> =>
    this.http.get<Task>(
      `https://js.devexpress.com/Demos/RwaService/api/Employees/Tasks/${id}`, { context: new HttpContext().set(BYPASS_LOG, true) }
    );

  public getTasks = (): Observable<Task[]> =>
    this.http.get<Task[]>(
      `https://js.devexpress.com/Demos/RwaService/api/Employees/AllTasks`, { context: new HttpContext().set(BYPASS_LOG, true) }
    );
}
